import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'vp-jumbotron',
    templateUrl: './jumbotron.component.html',
    styleUrls: ['./jumbotron.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class JumbotronComponent {
    @Input() public closable: boolean;
    @Input() public title: string;
    @Input() public imageSrc: string;

    @Output() public close = new EventEmitter<void>();

    public onClose(): void {
        this.close.emit();
    }
}
